export const HISTORY_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "AboutPage",
   "@id": "https://everest.ind.br/pt/historia/#webpage",
   "name": "Everest | História | 50 anos de tradição em água limpa",
   "url": "https://everest.ind.br/pt/historia",
   "description": "Conheça a história de 50 anos da Everest, pioneira em bebedouros elétricos, congeladores e purificadores no Brasil. Veja a trajetória em inovação e qualidade.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/#website"
   },
   "publisher": {
    "@id": "https://everest.ind.br/#organization"
   },
   "about": {
    "@id": "https://everest.ind.br/#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/historia/#breadcrumb"
   },
   "mainEntity": {
    "@id": "https://everest.ind.br/pt/historia/#organization-history"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/historia/#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Nossa História",
     "item": "https://everest.ind.br/pt/historia"
    }
   ]
  },
  {
   "@type": "Organization",
   "@id": "https://everest.ind.br/pt/historia/#organization-history",
   "name": "Everest",
   "foundingDate": "1966",
   "areaServed": "BR",
   "knowsAbout": [
    "Purificadores de água",
    "Filtros de água",
    "Refis para purificadores",
    "Máquinas de Gelo"
   ],
   "sameAs": {
    "@id": "https://everest.ind.br/#organization"
   }
  }
 ]
}
